import { useTerminalsStateRE } from "@/States/Terminals";
import { useCommonEntitiesStore } from "@/States/commonEntities";
import { trpc } from "@/Utils/trpc";
import { getTimeFrame } from "@/components/pageCards/filterSort/filterTimeFrame";
import {
  INumberEntryProps,
  NumberCard,
} from "@/components/pageCards/numberCard";
import { useConfigService } from "@/pages/configuration/useConfigService";
import { useAccessParents } from "@/pages/infrastructure/functions";
import { useTrans } from "@/translations";

import { useMemo, useState } from "react";

import { FilterTimeFrameValue } from "server/config-api/index.js";

import { getWastetypesInUse } from "../WasteTypesInUse/functions";

export const InfrastructureRE = () => {
  const { currentTerminal } = useTerminalsStateRE();
  const { t } = useTrans();
  const { manageAccessParentPageData: accessParentsData } = useAccessParents();

  const { terminalConfig } = useConfigService();

  const defaultPeriod = useMemo(
    () => terminalConfig?.defaultTimeFrame || FilterTimeFrameValue.Last30Days,
    [terminalConfig],
  );

  const [timeFrame] = useState(getTimeFrame(defaultPeriod));

  const { data: dwhData, isLoading } = trpc.dwh.terminals.getById.useQuery(
    {
      ...timeFrame,
      terminalId: currentTerminal.id,
    },
    {
      queryKeyHashFn: () =>
        [
          "terminal",
          currentTerminal.id,
          timeFrame.startTimeISO,
          timeFrame.endTimeISO,
        ].toString(),
    },
  );

  const { wasteTypes: sanityWasteTypes } = useCommonEntitiesStore();
  const containers = !!accessParentsData?.length
    ? accessParentsData.reduce(
        (previousValue, currentValue) =>
          previousValue + currentValue.containers.length,
        0,
      )
    : 0;

  const wasteTypesInUse = useMemo(
    () =>
      sanityWasteTypes && dwhData
        ? getWastetypesInUse(
            dwhData.terminal,
            accessParentsData,
            sanityWasteTypes,
          )
        : [],
    [dwhData, sanityWasteTypes, accessParentsData],
  );

  const numbers: INumberEntryProps[] = [
    {
      heading: t("entities:accessParents"),
      data: accessParentsData!.length | 0,
    },
    { heading: t("entities:containers"), data: containers | 0 },
    {
      heading: t("statisticsLabels:wasteCategories"),
      data: wasteTypesInUse.length | 0,
    },
  ];
  return (
    <NumberCard
      title="statisticsLabels:infrastructureSummary"
      numbers={numbers}
      isLoading={isLoading}
    />
  );
};
